import { LOCALE_STORAGE_KEYS } from 'config/localStorageKeys';
import { endOfDay } from 'date-fns';

export type CachedDonor = { id: string } & Record<string, any>;
export type CachedOwner = { id: string } & Record<string, any>;

type DonorMap = Record<string, CachedDonor>;
type OwnerMap = Record<string, CachedOwner>;

export const getCachedDonors = (): DonorMap =>
  JSON.parse(localStorage.getItem(LOCALE_STORAGE_KEYS.DONOR_CACHE) || '{}');

export const getCachedOwners = (): OwnerMap =>
  JSON.parse(localStorage.getItem(LOCALE_STORAGE_KEYS.OWNER_CACHE) || '{}');

export const saveDonorToCache = (donor: CachedDonor) => {
  const ids: string[] = JSON.parse(
    localStorage.getItem(LOCALE_STORAGE_KEYS.DONOR_IDS) || '[]'
  );

  if (!ids.includes(donor.id))
    localStorage.setItem(
      LOCALE_STORAGE_KEYS.DONOR_IDS,
      JSON.stringify([...ids, donor.id])
    );

  const CachedDonorsMap = getCachedDonors();
  CachedDonorsMap[donor.shortId] = donor;

  localStorage.setItem(
    LOCALE_STORAGE_KEYS.DONOR_CACHE,
    JSON.stringify(CachedDonorsMap)
  );

  localStorage.setItem(
    LOCALE_STORAGE_KEYS.DONOR_IDS_EXPIRATION_DATE,
    endOfDay(new Date()).toJSON()
  );

  const owner = donor.user as CachedOwner | undefined;
  if (owner?.shortId) {
    const owners = getCachedOwners();
    owners[owner.shortId] = owner;
    localStorage.setItem(
      LOCALE_STORAGE_KEYS.OWNER_CACHE,
      JSON.stringify(owners)
    );
  }
};
